export default "__VITE_ASSET__h7YjeUfL__"